import { useEffect, useRef } from 'react';
import { useClerk, useSignIn, useSignUp } from '@clerk/react';
import { useNavigate } from 'react-router-dom';

const SSOCallback = () => {
  const clerk = useClerk();
  const { signIn } = useSignIn();
  const { signUp } = useSignUp();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    (async () => {
      if (!clerk.loaded || hasRun.current || !signIn || !signUp) return;
      hasRun.current = true;

      try {
        if ((signIn.status as string) === 'complete') {
          await clerk.setActive({ session: signIn.createdSessionId });
          navigate('/', { replace: true });
          return;
        }

        if (signUp.isTransferable) {
          await signIn.create({ transfer: true });
          if ((signIn.status as string) === 'complete') {
            await clerk.setActive({ session: signIn.createdSessionId });
            navigate('/', { replace: true });
            return;
          }
        }

        if (signIn.isTransferable) {
          await signUp.create({ transfer: true });
          if ((signUp.status as string) === 'complete') {
            await clerk.setActive({ session: signUp.createdSessionId });
            navigate('/', { replace: true });
            return;
          }
        }

        if ((signUp.status as string) === 'complete') {
          await clerk.setActive({ session: signUp.createdSessionId });
          navigate('/', { replace: true });
          return;
        }

        navigate('/login', { replace: true });
      } catch (err) {
        console.error('SSO callback error:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [clerk, signIn, signUp, navigate]);

  return (
    <div className="auth-loading">
      <div className="auth-spinner" />
    </div>
  );
};

export default SSOCallback;
